import { render, staticRenderFns } from "./AutomatedDropsTracker.vue?vue&type=template&id=faf841f4"
import script from "./AutomatedDropsTracker.vue?vue&type=script&lang=js"
export * from "./AutomatedDropsTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports